import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {Observable, of, Subscription} from "rxjs";
import {IrbMMCSettingsService} from "@irb/irb-settings/settings-mmc/irb-mmc-settings.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {AppService} from "@irb/app.service";
import {IrbSettingsEvents} from "@irb/irb-settings/irb-settings.events";
import {IEvent, IrbAppEvents} from "@irb-common/events";
import {MmcSettingsNotificationsPage} from "@irb/irb-settings/settings-mmc/settings-mmc-notes/irb-mmc-settings-notifications.page";
import {SettingsMmcNotesGridLayoutService} from "@irb/irb-settings/settings-mmc/settings-mmc-notes/settings-mmc-notes.grid-layout.service";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {HttpErrorResponse} from "@angular/common/http";

@Component({ standalone: false,
    selector: 'irb-settings-mmc-notes',
    templateUrl: './settings-mmc-notes.component.html',
    styleUrls: ['./settings-mmc-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SettingsMmcNotesComponent implements MmcSettingsNotificationsPage<any>, OnInit, OnDestroy {
    @ViewChild('irbModelProviderDropdown') irbModelProviderDropdown: DropdownFilterComponent;
    @ViewChild('irbModelDropdown') irbModelDropdown: DropdownFilterComponent;

    _modelMarketNotifications: any;
    originalModelMarketNotifications: any;
    _isModified: boolean;
    eventSubscription: Subscription;
    showUnsavedChangesWarning: boolean = false;
    showExpandControls: boolean = false;
    gridOptions: any;
    grid: any;
    frameworkComponents: any;
    modelProvidersList: IDropdownItem[] = [];
    modelsList: any[] = []
    selectedModelProvider: any
    selectedModel: any;
    userConfig: any;
    validationErrors: string[];
    validationErrorTemplates: TemplateRef<any>[];

    constructor(
        public mmcSettingService: IrbMMCSettingsService,
        public gls: SettingsMmcNotesGridLayoutService,
        private cdr: ChangeDetectorRef,
        private util: UtilityService,
        private as: AppService,
        private ctas: CalltoactionService
        ) {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
    }

    ngOnInit() {
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),            
            floatingFilter: false,
            overlayNoRowsTemplate:
                "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No notes defined.</span>",
            context: {componentParent: this},
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
        };
        
        this.frameworkComponents = this.gls.getFrameworkComponents();
        this.mmcSettingService.getModelMarketNotifications().subscribe((data: any) => {
            this.load(data);
        });
        this.mmcSettingService.getModelProviders().subscribe((data: any) => {
            if (data && data.items && data.items.length > 0) {
                data.items.forEach((x: any) => {
                    let dropdownItem: IDropdownItem = {name: x.name, value: x.id};
                    this.modelProvidersList.push(dropdownItem);
                });

            } else {
                this.modelProvidersList = [];
            }

        });
        //if(this.irbModelDropdown){
            //this.irbModelDropdown.setDisabled(true);
        //}
        this.cdr.detectChanges();
    }

    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return !node.data.isUIdeleted;
    }

    ngOnDestroy() {
        this.eventSubscription.unsubscribe();
    }

    onInputChange(): any {
        window.setTimeout(() => {
            this.isModified = !this.util.compare(this.originalModelMarketNotifications, this.modelMarketNotifications);
            this.as.fireEvent((this.isModified) ? IrbSettingsEvents.IS_MODIFIED : IrbSettingsEvents.IS_NOT_MODIFIED);
            this.validateInput().subscribe(_validationErrors => {});
            this.cdr.detectChanges();
        });
    }

    validateInput(): Observable<string[]> {
        this.validationErrors = [];
        this.validationErrorTemplates = [];

        if (!this.hasAllNotes()) {
            this.validationErrors.push("One or more notes do not have any content.");
        }

        return of(this.validationErrors);
    }

    load(data: any): void {
        this.selectedModel = null;
        this.selectedModelProvider = null;
        this.modelMarketNotifications = data;
        this.originalModelMarketNotifications = this.util.clone(this.modelMarketNotifications);
        this.isModified = false;
        this.showUnsavedChangesWarning = false;
        this.as.fireEvent(IrbSettingsEvents.IS_NOT_MODIFIED);
        this.loadGrid();
        this.cdr.detectChanges();
    }

    save(): void {
        this.validateInput().subscribe((errorMessages: string[]) => {
            if (errorMessages && errorMessages.length > 0) {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'error',
                    summary: 'Save',
                    detail: errorMessages[0]
                });
            } else {
                this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
                let objectToSave = this.modelMarketNotifications;
                this.mmcSettingService.saveModelMarketNotifications(objectToSave).subscribe((response: any) => {
                    if (response) {
                        if (response.success) {
                            this.as.fireEvent(IrbSettingsEvents.SAVE_SUCCESS, "Model Market Center notes were updated.");
                            this.load(response.data);
                        } else {
                            let errorMessages = response.errorMessages;
                            if (errorMessages && errorMessages.length > 0) {
                                errorMessages.forEach((errorMessage: any) => {
                                    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                                        severity: 'error',
                                        summary: '',
                                        detail: errorMessage
                                    });
                                });
                            }
                        }
                    } else {
                        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                            severity: 'error',
                            summary: '',
                            detail: 'An error occurred processing your request.'
                        });
                    }

                }, (err: HttpErrorResponse) => {
                    false && console.error(err);
                    this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR, "An error occurred sending your request.");
                }, () => {
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                });
            }
        });
    }

    processEvent(event: IEvent) {
        switch (event.type) {
            case IrbSettingsEvents.SAVE:
                this.save();
                break;
            case IrbSettingsEvents.UNSAVED_CHANGES:
                if (this.isModified) {
                    this.showUnsavedChangesWarning = true;
                    this.cdr.detectChanges();
                }
                break;
            case IrbSettingsEvents.REVERT_CHANGES:
                this.revert();
                break;
        }
    }

    revert(): void {
        this.load(this.originalModelMarketNotifications);
    }

    get modelMarketNotifications() {
        return this._modelMarketNotifications;
    }

    set modelMarketNotifications(newModelMarketNotifications: any) {
        this._modelMarketNotifications = newModelMarketNotifications;
    }

    get isModified() {
        return this._isModified;
    }

    set isModified(newIsModified: boolean) {
        this._isModified = newIsModified;
    }

    private loadGrid() {
        if (this.grid && this.grid.api && this.modelMarketNotifications) {
            this.grid.api.setGridOption('rowData', this.modelMarketNotifications);
        }
    }

    onAddMmcNote() {
        if (this.selectedModelProvider) {
            this.userConfig = this.as.getItem('IRB_APP_CONFIG');
            let newObj: any = {
                modelMarketAdminNoteId: null,
                createdDate: (new Date()).getTime(),
                creator: this.userConfig.userID,
                comment: "",
                isNew: true,
                isUIdeleted: false,
                isUpdated: false,
                priority: "Normal",
                modelProviderId: this.selectedModelProvider.value,
                modelProviderName: this.selectedModelProvider.name,
                modelMarketId: (this.selectedModel && this.selectedModel?.value) ? this.selectedModel?.value : null,
                modelMarketName: (this.selectedModel && this.selectedModel?.value) ? this.selectedModel?.name : null,
                versionId: null
            };
            this.modelMarketNotifications.push(newObj);
            this.selectedModelProvider = null;
            this.selectedModel = null;
            this.loadGrid();
            this.onInputChange();
        }
    }

    getCount() {
        return this.modelMarketNotifications?.length ? this.modelMarketNotifications.length : 0;
    }

    getNonDeletedNotes() {
        if(this.modelMarketNotifications) {
            let nonDeleted =  this.modelMarketNotifications.filter((x:any) => !x.isUIdeleted);
            return nonDeleted.length;
        } else  {
            return 0;
        }

    }

    onGridReady(params: any) {
        this.grid = params;
    }

    cancelDelete() {
        this.ctas.remove();
    }

    delete(data: any) {
        if (data.isNew) {
            let itemToRemoveIndex = this.modelMarketNotifications.findIndex((x: any) => x.createdDate === data.createdDate);
            let removedItem = this.modelMarketNotifications.splice(itemToRemoveIndex, 1);
        } else {
            data.isUIdeleted = true;
        }
        this.ctas.remove();
        this.loadGrid();
        this.onInputChange();
    }

    deleteAll() {
        if (this.modelMarketNotifications && this.modelMarketNotifications.length > 0) {
            this.modelMarketNotifications = this.util.clone(this.originalModelMarketNotifications);
            this.modelMarketNotifications.forEach((data: any) => {
                data.isUIdeleted = true;
            });
        }
        this.ctas.remove();
        this.loadGrid();
        this.onInputChange();
    }

    searchModelProviders(searchStr: string) {

        let items = JSON.parse(JSON.stringify(this.modelProvidersList));
        this.util.sortByKey(items, "name", "asc");
        this.irbModelProviderDropdown.set(DropdownFilterComponent.getFilteredList(searchStr, items));
    }


    searchModels(searchStr: string) {
        let items: IDropdownItem[] = [];
        this.modelsList.forEach((x: any) => {
            let dropdownItem: IDropdownItem = {name: x.modelMarketName, value: x.modelMarketId};
            items.push(dropdownItem);
        });
        this.util.sortByKey(items, "name", "asc");
        items.unshift({
            value: null,
            name: "All"
        } as IDropdownItem);
        this.irbModelDropdown.set(DropdownFilterComponent.getFilteredList(searchStr, items));
    }

    onModelProviderSelection(selectedProvider: any) {
        this.selectedModel = {
            value: null,
            name: "All"
        };
        if (selectedProvider) {
            this.mmcSettingService.getModelMarketProviderModels(selectedProvider.value).subscribe((data: any) => {
                if (data && data.items && data.items.length > 0) {
                    this.modelsList = data.items;

                } else {
                    this.modelsList = [];
                }
            });
            //this.irbModelDropdown.setDisabled(false);
        } else {
            this.modelsList = [];
            this.selectedModel = null;
            //this.irbModelDropdown.setDisabled(true);
        }
    }

    onPriorityChanged(params: any) {
        if (!params.data.isNew) {
            let originalObj = this.originalModelMarketNotifications.find((x: any) => x.modelMarketAdminNoteId === params.data.modelMarketAdminNoteId);
            if (originalObj.priority !== params.data.priority) {
                params.data.isUpdated = true;
            } else {
                params.data.isUpdated = false;
            }
        }
        this.onInputChange();
    }

    onCellValueChanged(params: any) {
        const colId = params.column.getId();
        if (colId === "comment") {
            if (!params.data.isNew) {
                let originalObj = this.originalModelMarketNotifications.find((x: any) => x.modelMarketAdminNoteId === params.data.modelMarketAdminNoteId);
                if (originalObj.comment !== params.data.comment) {
                    params.data.isUpdated = true;
                } else {
                    params.data.isUpdated = false;
                }
            }
            this.onInputChange();
        }
    }

    hasAllNotes() {
        let returnValue = true;
        if (this.modelMarketNotifications && this.modelMarketNotifications.length > 0) {
            let index = this.modelMarketNotifications.findIndex((x: any) => !(x.comment));
            returnValue = index < 0;
        }
        return returnValue;
    }

    getRowCount() {
        return (this.modelMarketNotifications) ? this.modelMarketNotifications.length : 0;
    }

}
